import React, { FC } from 'react';
import { GenericPage } from '../../../app/pages/ui/GenericPage';

import { useSetFlightsEnrichmentData } from '../../shared/flight/ui/useSetFlightsEnrichmentData';
import { IFlightDetailsPageData } from '../domain/models/IFlightDetailsPageData';
import { FlightDetailContent } from './FlightDetailContent';
import { FlightDetailPageDepartureCTA } from './FlightDetailsPageDepartureCTA';

interface IFlightDetailsPageProps extends IFlightDetailsPageData {}

export const FlightDetailsPage: FC<IFlightDetailsPageProps> = ({
	page,
	flightsEnrichmentData,
	highlightImage,
}) => {
	useSetFlightsEnrichmentData(flightsEnrichmentData);

	return (
		<GenericPage page={page} overlapContentWithHeader>
			<FlightDetailContent highlightImage={highlightImage} />
			<FlightDetailPageDepartureCTA />
		</GenericPage>
	);
};
